import Vue from "vue";
import App from "./App.vue";
import toastr from "vue-toastr";
import VueI18n from 'vue-i18n'
import LangEn from './language/en_US'
import router from "./router";
import store from "./store";
import config from "./config";
import DatatableFactory from 'vuejs-datatable/dist/vuejs-datatable.esm.js';
import dayjs from 'dayjs'
import './style/style.scss'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import './style/element-variables.scss'
import lodash from 'lodash'
Vue.use(ElementUI, { locale });
import { Loading } from 'element-ui'

// import VeeValidate from 'vee-validate';

// Vue.use(VeeValidate);
Vue.use(VueI18n)
Vue.use(toastr,{
    defaultPosition: 'toast-bottom-center',
})

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$lodash = lodash;

const i18n = new VueI18n({
    locale: 'en_US',
    messages: {
        'en_US': LangEn,
    }
})

Vue.config.productionTip = false;
Vue.use(DatatableFactory);

import CKEditor from '@ckeditor/ckeditor5-vue2';
Vue.use(CKEditor);

import axios from "axios"

Vue.prototype.$axios = axios
//获取request error

var mixin = {
  data() {
    return {
      langData: ["English", "Simplified Chinese", "Traditional Chinese"],
      langKey: ["en_US", "zh_HK", "zh_CN"],
      fileUploadUrl: config.fileUploadUrl,
      fileBase64UploadUrl: config.fileBase64UploadUrl,
    }
  }
}


new Vue({
  mixins: [mixin],
  router,
  i18n,
  store,
  toastr,
  axios,
  render: h => h(App)
}).$mount("#app");


